const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class HotspotCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-45%',
      threshold: 0,
    })

    this.observer.observe(this)
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTriggerClick)
    })
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.classList.add('sec-Hotspots-active')

    observer.unobserve(this)
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.3,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            loop: false,
            slides: {
              perView: 1.8,
              spacing: 5,
            },
          },
          '(min-width: 901px)': {
            renderMode: 'custom',
            loop: true,
            slides: {
              perView: 1,
              spacing: 5,
            },
          },
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel

          this.els.trigger.elements.forEach((triggerEl) => {
            triggerEl.setAttribute(
              'aria-pressed',
              triggerEl.dataset.index === activeIndex.toString(),
            )
          })

          this.els.slide.elements.forEach((slideEl) => {
            slideEl.setAttribute(
              'aria-hidden',
              slideEl.dataset.index !== activeIndex.toString(),
            )
          })
        },
      },
      [setInitialised()],
    )
  }

  handleTriggerClick (event) {
    const clickedTrigger = event.target

    if (window.BAO.MediaBreakpoints.isMd) {
      this.carousel.track.to(parseInt(clickedTrigger.dataset.index))
    } else {
      this.carousel.moveToIdx(parseInt(clickedTrigger.dataset.index))
    }
  }
}

if (!customElements.get('hotspot-carousel')) {
  customElements.define('hotspot-carousel', HotspotCarousel)
}
